export enum ObjectType {
  work = 'work',
  work_work = 'work_work',
  work_materialization = 'work_materialization',
  museum_object = 'museum_object',
  archive_object = 'archive_object',
  materialization = 'materialization',
  descriptor_object = 'descriptor_object'
}
